import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@api/api-configuration';
import { BaseService } from '@api/base-service';
import { CountriesResponse } from '@app/shared/models/country';

@Injectable({
  providedIn: 'root',
})
export class CountriesApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  // GET /api/Countries
  getAllCountries(): Observable<CountriesResponse[]> {
    return this.http.get<CountriesResponse[]>(`${this.rootUrl}/countries`);
  }

  getScandinavianCountries(): Observable<CountriesResponse[]> {
    return this.http.get<CountriesResponse[]>(`${this.rootUrl}/countries/scandinavia`);
  }
}
